export const STRINGS = {
	categories: 'Kategoriler',
	description: 'Açıklama',
	pricing: 'Ücretlendirme',
	end_points: 'End Points',
	show: 'Görüntüle',
	example: 'Örnek',
	request: 'Request',
	response: 'Response',
	copy: 'Kopyala',
	parameters: 'Parametreler',
	field: 'Alan',
	type: 'Tip',
	contanct_us: 'İletişim',
	terms_and_conditions: 'Kullanım Koşulları',
	privicy_policy: 'Gizlilik',
	powered_by: 'Powered by Dahi.ai',
	publish_api: 'API Yayınla',
};

export const GET_END_POINTS_URL = '/rest/apis/getEndpoints/';
export const GET_APIS_URL = '/rest/apis/list/';
export const GET_TAGS_APIS_URL = '/rest/apis/tags/';

export const PRICE_PER_CALL = 0.001;

export const API_URL = 'https://api.collectapi.com';
